import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Alert,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import CloseIcon from '@mui/icons-material/Close';
import { GoAlert } from 'react-icons/go';

import { useUserContext } from '../../context/user';
import { useAuthContext } from '../../context/auth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

const Reset = ({ user }) => {
  const axiosPrivate = useAxiosPrivate();
  const { dispatch } = useUserContext();
  const { auth } = useAuthContext();
  const theme = useTheme();

  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);

  const handleReset = async () => {   
    try {
      const response = await axiosPrivate.patch(`/api/users/${user._id}`);
      dispatch({ type: 'RESET_USER', payload: response.data });
      setError(null);
      setShow(false);
    } catch (error) {
      setError(error.response?.data.error);
    }    
  };

  return (
    <>
      <Tooltip title="Reset State">
        <IconButton
            color="secondary"
            size="small"
            onClick={() => setShow(true)}
        >
          <LockResetIcon />
        </IconButton>
      </Tooltip>

      <Dialog
        open={show}
        onClose={() => {
          setShow(false);
          setError(null);
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            backgroundColor: theme.palette.background.default,
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.text.primary,
            fontWeight: 'bold',
          }}
        >
          {!error && <GoAlert size={22} color={theme.palette.error.main} />}
          {error ? 'Error' : 'Warning'}
          <IconButton
            onClick={() => {
              setShow(false);
              setError(null);
            }}
            sx={{ marginLeft: 'auto', color: theme.palette.text.primary }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary
          }}
        >
          {!error ? (
            <Typography sx={{ marginTop: '20px' }}>
              Are you sure you want to reset the state of user <strong>{user.name}</strong>?
            </Typography>
          ) : (
            <Alert severity="error">{error}</Alert>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            backgroundColor: theme.palette.background.default,
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          {!error && (
            <Button
              onClick={handleReset}
              variant="contained"
              color="error"
              sx={{ textTransform: 'none' }}
            >
              Reset
            </Button>
          )}
          <Button
            onClick={() => {
              setShow(false);
              setError(null);
            }}
            variant="outlined"
            color="secondary"
            sx={{ textTransform: 'none' }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Reset;
